import { Ticket } from 'types';
import { baseQuery } from '../baseQuery';

export type PutTicketParams = {
  ticketId: number;
  typeId?: number;
  isTechVisible?: boolean;
  etaDate?: string;
  hasRemoveEta?: boolean;
  successMessage?: string;
};

export const putTicket = async ({ ticketId, typeId, isTechVisible, etaDate, hasRemoveEta }: PutTicketParams) => {
  const data = await baseQuery('ticket', {
    type: 'PUT',
    body: {
      ticket_id: ticketId,
      ticket_type_id: typeId,
      technician_visible: isTechVisible !== undefined ? Number(isTechVisible) : undefined,
      eta_date: etaDate,
      remove_eta_date: hasRemoveEta !== undefined ? Number(hasRemoveEta) : undefined,
    },
  });

  return data as Ticket;
};
